<template>
  <main-content>
    <div>
        <deposit-filter @exportExcel="exportExcel" :action="filterAction"></deposit-filter>
        <div class="switch-div">
            انتقال های من
            <label class="switch m-0 mr-2 ml-2">
                <input id="application_checkbox" type="checkbox" @change="checkbox_changed">
                <span class="slider round"></span>
            </label>
            تمام انتقال ها
        </div>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
  </main-content>
</template>

<script>
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import axios from "axios";
import {i18n} from "@/plugins/i18n";
import MainContent from "@/components/main-content.vue";
import depositColumns from "@/views/openBanking/components/manage-access/datatable/deposit-columns";
import DepositFilter from "@/views/openBanking/components/manage-access/deposit-filter.vue";

export default {

    components: {
      DepositFilter,
      MainContent,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "bank_transfer_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('open-banking/application/admin/deposits'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params:  this.query,
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: depositColumns,
            }
        },
    },
    methods: {
        exportExcel() {
            let btn = $('#export_excel')
            KTApp.progress(btn)

            axios({
                url: ApiUrl.path(`open-banking/requests/admin/bank-transfer/export-excel`),
                method: 'GET',
                params: this.query,
                responseType: 'blob',
            }).then((response) => {
                KTApp.unprogress(btn);
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'transfer-transactions.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(i18n.t('message.an_error_accord'))
                KTApp.unprogress(btn)
            })
        },
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#application_checkbox')

            if (checkbox.is(":checked"))
                this.query.my_requests = 1
            else
                this.query.my_requests = 0

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style scoped>
.slider {
    background-color: #757575;
}

.slider.round {
    border-radius: 100px;
}

.slider.round:before {
    border-radius: 100px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 43px;
    height: 19px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #575757;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 1px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}
</style>